export const currentMonth = (
  day: number,
  padding = 0,
  baseDate = new Date()
) => {
  const date = new Date(baseDate.getFullYear(), 1, day);
  date.setMonth(baseDate.getMonth() + padding);
  return date;
};
